/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

var $Writer = $protobuf.Writer, $util = $protobuf.util;

var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.endpointevent = (function() {

    var endpointevent = {};

    endpointevent.EventID = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[80010] = "MMSGetEndpointCfgEvent"] = 80010;
        return values;
    })();

    endpointevent.EventList = (function() {

        function EventList(p) {
            this.events = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        EventList.prototype.events = $util.emptyArray;

        EventList.create = function create(properties) {
            return new EventList(properties);
        };

        EventList.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.events != null && m.events.length) {
                for (var i = 0; i < m.events.length; ++i)
                    $root.endpointevent.Event.encode(m.events[i], w.uint32(10).fork()).ldelim();
            }
            return w;
        };

        return EventList;
    })();

    endpointevent.Event = (function() {

        function Event(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Event.prototype.header = null;
        Event.prototype.body = $util.newBuffer([]);

        Event.create = function create(properties) {
            return new Event(properties);
        };

        Event.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.header != null && Object.hasOwnProperty.call(m, "header"))
                $root.endpointevent.Header.encode(m.header, w.uint32(10).fork()).ldelim();
            if (m.body != null && Object.hasOwnProperty.call(m, "body"))
                w.uint32(18).bytes(m.body);
            return w;
        };

        return Event;
    })();

    endpointevent.Header = (function() {

        function Header(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Header.prototype.id = 0;
        Header.prototype.sceneId = 0;
        Header.prototype.uid = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        Header.prototype.deviceId = "";
        Header.prototype.deviceModel = "";
        Header.prototype.os = 0;
        Header.prototype.osVersion = "";
        Header.prototype.clientVersion = "";
        Header.prototype.clientIp = "";
        Header.prototype.network = 0;
        Header.prototype.country = "";
        Header.prototype.ua = "";
        Header.prototype.sdkVersion = "";
        Header.prototype.timestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        Header.prototype.adjustTimestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        Header.prototype.sdkType = 0;
        Header.prototype.bodyFormat = 0;
        Header.prototype.abTest = "";
        Header.prototype.appType = 0;
        Header.prototype.rnVersion = "";
        Header.prototype.channel = "";
        Header.prototype.biz = 0;
        Header.prototype.samplePercent = 100;
        Header.prototype.dataSourceType = 0;

        Header.create = function create(properties) {
            return new Header(properties);
        };

        Header.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.id != null && Object.hasOwnProperty.call(m, "id"))
                w.uint32(8).uint32(m.id);
            if (m.sceneId != null && Object.hasOwnProperty.call(m, "sceneId"))
                w.uint32(16).uint32(m.sceneId);
            if (m.uid != null && Object.hasOwnProperty.call(m, "uid"))
                w.uint32(24).uint64(m.uid);
            if (m.deviceId != null && Object.hasOwnProperty.call(m, "deviceId"))
                w.uint32(34).string(m.deviceId);
            if (m.deviceModel != null && Object.hasOwnProperty.call(m, "deviceModel"))
                w.uint32(42).string(m.deviceModel);
            if (m.os != null && Object.hasOwnProperty.call(m, "os"))
                w.uint32(48).uint32(m.os);
            if (m.osVersion != null && Object.hasOwnProperty.call(m, "osVersion"))
                w.uint32(58).string(m.osVersion);
            if (m.clientVersion != null && Object.hasOwnProperty.call(m, "clientVersion"))
                w.uint32(66).string(m.clientVersion);
            if (m.clientIp != null && Object.hasOwnProperty.call(m, "clientIp"))
                w.uint32(74).string(m.clientIp);
            if (m.network != null && Object.hasOwnProperty.call(m, "network"))
                w.uint32(80).uint32(m.network);
            if (m.country != null && Object.hasOwnProperty.call(m, "country"))
                w.uint32(90).string(m.country);
            if (m.ua != null && Object.hasOwnProperty.call(m, "ua"))
                w.uint32(98).string(m.ua);
            if (m.sdkVersion != null && Object.hasOwnProperty.call(m, "sdkVersion"))
                w.uint32(106).string(m.sdkVersion);
            if (m.timestamp != null && Object.hasOwnProperty.call(m, "timestamp"))
                w.uint32(112).uint64(m.timestamp);
            if (m.adjustTimestamp != null && Object.hasOwnProperty.call(m, "adjustTimestamp"))
                w.uint32(120).uint64(m.adjustTimestamp);
            if (m.sdkType != null && Object.hasOwnProperty.call(m, "sdkType"))
                w.uint32(128).uint32(m.sdkType);
            if (m.bodyFormat != null && Object.hasOwnProperty.call(m, "bodyFormat"))
                w.uint32(136).uint32(m.bodyFormat);
            if (m.abTest != null && Object.hasOwnProperty.call(m, "abTest"))
                w.uint32(146).string(m.abTest);
            if (m.appType != null && Object.hasOwnProperty.call(m, "appType"))
                w.uint32(152).uint32(m.appType);
            if (m.rnVersion != null && Object.hasOwnProperty.call(m, "rnVersion"))
                w.uint32(162).string(m.rnVersion);
            if (m.channel != null && Object.hasOwnProperty.call(m, "channel"))
                w.uint32(170).string(m.channel);
            if (m.biz != null && Object.hasOwnProperty.call(m, "biz"))
                w.uint32(176).uint32(m.biz);
            if (m.samplePercent != null && Object.hasOwnProperty.call(m, "samplePercent"))
                w.uint32(184).uint32(m.samplePercent);
            if (m.dataSourceType != null && Object.hasOwnProperty.call(m, "dataSourceType"))
                w.uint32(192).uint32(m.dataSourceType);
            return w;
        };

        return Header;
    })();

    endpointevent.GetEndpointCfgEvent = (function() {

        function GetEndpointCfgEvent(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GetEndpointCfgEvent.prototype.actionId = 0;
        GetEndpointCfgEvent.prototype.cost = 0;
        GetEndpointCfgEvent.prototype.triggerScene = 0;
        GetEndpointCfgEvent.prototype.ver = 0;
        GetEndpointCfgEvent.prototype.retryCount = 0;
        GetEndpointCfgEvent.prototype.latitude = 0;
        GetEndpointCfgEvent.prototype.longitude = 0;

        GetEndpointCfgEvent.create = function create(properties) {
            return new GetEndpointCfgEvent(properties);
        };

        GetEndpointCfgEvent.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            w.uint32(8).uint32(m.actionId);
            if (m.cost != null && Object.hasOwnProperty.call(m, "cost"))
                w.uint32(16).uint32(m.cost);
            if (m.triggerScene != null && Object.hasOwnProperty.call(m, "triggerScene"))
                w.uint32(24).uint32(m.triggerScene);
            if (m.ver != null && Object.hasOwnProperty.call(m, "ver"))
                w.uint32(32).uint32(m.ver);
            if (m.retryCount != null && Object.hasOwnProperty.call(m, "retryCount"))
                w.uint32(40).uint32(m.retryCount);
            if (m.latitude != null && Object.hasOwnProperty.call(m, "latitude"))
                w.uint32(49).double(m.latitude);
            if (m.longitude != null && Object.hasOwnProperty.call(m, "longitude"))
                w.uint32(57).double(m.longitude);
            return w;
        };

        return GetEndpointCfgEvent;
    })();

    return endpointevent;
})();

module.exports = $root;
